<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<div class="card">
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="redirectZon()"></button>
            <button pButton pRipple label="{{translations.lbl_new}} {{translations.lbl_record}}" icon="pi pi-plus"
                class="p-button-success p-mr-2" (click)="openNew()"></button>
        </ng-template>
    </p-toolbar>

    <p-table #dt [value]="listNatioCoord" [rows]="20" [paginator]="true" [globalFilterFields]="" [columns]="columns"
        dataKey="natId" styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_list}} {{translations.lbl_coordination}}
                    {{translations.lbl_national}} </h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th>
                    {{translations.lbl_address}}
                </th>
                <th>
                    {{translations.lbl_actions}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-natio>
            <tr>
                <td *ngFor="let col of columns">
                    <span class="p-column-title">{{col.header}}</span>
                    {{getLastField(natio,col.field)}}
                </td>
                <td>
                    <span class="p-column-title">{{translations.lbl_address}}</span>
                    {{formatAddress(natio.storeAddress)}}
                </td>
                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        (click)="editCoord(natio)"></button>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-error p-mr-2"
                        (click)="selectionCoordinationCatalog(natio)"></button>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{translations.lbl_there_are}} {{listNatioCoord ? listNatioCoord.length : 0
                }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>